var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { HelperButton, SimpleTableRow } from '@sovryn/ui';
export const Row = (_a) => {
    var { label, tooltip } = _a, props = __rest(_a, ["label", "tooltip"]);
    return (React.createElement(SimpleTableRow, Object.assign({ className: "flex flex-row justify-between gap-4 items-center", label: React.createElement("div", { className: "flex flex-row gap-2 justify-start items-center whitespace-nowrap" },
            label,
            tooltip && React.createElement(HelperButton, { content: tooltip })) }, props)));
};
